import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { Mic } from './Mic';
import './VoiceInput.css';

interface VoiceInputProps extends InputHTMLAttributes<HTMLInputElement> {
  onVoiceStart?: () => void;
  onVoiceStop?: () => void;
}

export const VoiceInput = forwardRef<HTMLInputElement, VoiceInputProps>(function VoiceInput(
  { onVoiceStart, onVoiceStop, className = '', ...rest },
  ref
) {
  return (
    <div className={`voice-input ${className}`.trim()}>
      <input ref={ref} type="text" className="voice-input__field" {...rest} />
      <Mic size="workbench" onStart={onVoiceStart} onStop={onVoiceStop} />
    </div>
  );
});
